<template>
  <div id="app">
    <y-header :scroll="scroll"></y-header>
    <router-view/>
    <y-footer></y-footer>
  </div>
</template>

<script>
import header from './components/header.vue'
import footer from './components/footer.vue'
export default {
  data(){
    return{
      scroll:false
    }
  },
  name: 'app',
  components: {
    'y-header': header,
    'y-footer': footer
  },
  created(){
    window.addEventListener('scroll', this.handleScroll)
  },
  methods:{
    handleScroll () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      //console.log(scrollTop)
      if (scrollTop === 0){
        this.scroll = false
      }else {
        this.scroll = true
      }
    },
  },
  mounted () {
    const script = document.createElement('script')
    script.src = 'https://s95.cnzz.com/z_stat.php?id=1272997679&web_id=1272997679'
    script.language = 'JavaScript'
    document.body.appendChild(script)
  },
  watch: {
    '$route' () {
      if (window._czc) {
        let location = window.location
        let contentUrl = location.pathname + location.hash
        let refererUrl = '/'
        window._czc.push(['_trackPageview', contentUrl, refererUrl])
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue